import QdtComponents from 'qdt-components';

const options = {
  config: {
    host: 'qap.ipc-global.com',
    appId: '747b3772-4c68-492a-b4c8-373a1b5934b7',
    secure: true,
    port: 443,
    prefix: '',
  },
  connections: {
    vizApi: true,
    engineApi: true,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

export { qdtComponents };
